import React, { Component } from "react";

class PlainDiv extends Component {
    render() {
        return <div className={`plain-div ${this.props.className || ""}`} style={this.props.style || {}}>
            {this.props.children}
        </div>
    }
}

export default PlainDiv;